<template>
  <v-form ref="form" v-on:submit.prevent v-model="valid">
    <p>Тип клиента</p>
    <v-radio-group :rules="[rules.required('')]" v-model="client_type" row>
      <v-radio color="#88BD1F" label="Физ. Лицо (регистрация бизнеса)" value="FL"></v-radio>
    </v-radio-group>

    <div v-if="client_type === 'FL'">
      <v-row no-gutters>
        <v-col cols="12" class="font--color_light font--label mb-9">
          <MaskedTextField
            :pattern="/[А-Яа-яёЁ-]/"
            :rules="[rules.required('Введите фамилию контактного лица')]"
            v-model="person_surname"
            label="Фамилия контактного лица"
          />
        </v-col>
        <v-col cols="12" class="font--color_light font--label mb-9">
          <MaskedTextField
            :pattern="/[А-Яа-яёЁ]/"
            :rules="[rules.required('Введите имя контактного лица')]"
            v-model="person_firstname"
            label="Имя контактного лица"
          />
        </v-col>
        <v-col cols="12" class="font--color_light font--label mb-9">
          <MaskedTextField
            :pattern="/[\sА-Яа-яёЁ]/"
            :rules="[rules.required('Введите отчество контактного лица')]"
            v-model="person_middlename"
            label="Отчество контактного лица"
          />
        </v-col>
        <v-col cols="12" class="font--color_light font--label mb-3">
          <v-text-field
            dense
            :rules="[rules.required('Введите ИНН'), rules.inn]"
            outlined
            v-model="inn_physical"
            name="inn"
            label="ИНН физического лица"
            v-mask="['##########', '############']"
          />
        </v-col>
      </v-row>
      <v-row no-gutters>
        <v-col cols="12" sm="6" class="font--color_light font--label pr-sm-2">
          <v-text-field
            :rules="[rules.required('Введите Номер телефона'), rules.phone]"
            outlined
            required
            style="text-align: center"
            label="Телефон контактного лица"
            name="phone"
            type="text"
            v-model="phone"
            dense
          >
          </v-text-field>
        </v-col>
        <v-col cols="12" sm="6" class="font--color_light font--label">
          <v-text-field :rules="[rules.email]" v-model="email" outlined label="Электронная почта" dense />
        </v-col>
      </v-row>
      <v-row no-gutters>
        <v-col cols="12" class="font--color_light font--label">
          <v-textarea
            counter="2048"
            :rules="[rules.comment]"
            label="Комментарий"
            rows="3"
            outlined
            v-model="comment"
          ></v-textarea>
        </v-col>
      </v-row>

      <AutocreditUploadSection />
    </div>
    <v-btn color="primary" :disabled="!valid || passportFiles.length === 0" @click="sendBid"
      >Создать заявку</v-btn
    >
  </v-form>
</template>

<script>
import { mask } from "vue-the-mask";
import { validateInn, validateOgrn } from "@/utils/helpers";
import { email as ruleEmail } from "@/utils/rules";
import { mapActions, mapGetters, mapState, mapMutations } from "vuex";
import CompanySearch from "@/components/common/CompanySearch";
import MaskedTextField from "@/components/common/MaskedTextField";
import formatPhone from "../../utils/formatPhone";
import AutocreditUploadSection from "./AutocreditUploadSection.vue";

export default {
  directives: { mask },
  data() {
    return {
      isNewCompany: false,
      valid: false,
      productList: [
        {
          value: "ACCOPEN",
          label: "РКО",
        },
        {
          value: "MERCHANT.IA",
          label: "Интернет эквайринг",
        },
        {
          value: "MODULKASSA",
          label: "Касса",
        },
        {
          value: "MERCHANT.TA",
          label: "Торговый эквайринг",
        },
        {
          value: "CLOUDPAY",
          label: "Облачные чеки",
          disabledState: false, // FIXME: сервер может отправлять условия, нужно забирать (место пока не определено)
          hint: "Доступно вместе с РКО",
        },
      ],

      rules: {
        required: (msg) => (v) => !!v || msg,
        inn: (v) => (validateInn(v) && this.isInnMatchOgrn) || "Введите корректный ИНН",
        ogrn: (v) => !v || (validateOgrn(v) && this.isOgrnMatchInn) || "Введите корректный " + this.ogrnLabel,
        email: (v) => !v || ruleEmail(v),
        phone: (v) => v.replace(/\D/g, "").length === 11 || "Введите номер телефона",
        comment: (v) => !v || v.length <= 2048 || "Максимум 2048 символов",
      },
    };
  },
  computed: {
    ...mapGetters("common", ["errdesc"]),

    ...mapState({
      stg: (state) => state.bid.stg,
      stateInn: (state) => state.bid.inn,
      statePhone: (state) => state.bid.person_phone,
      stateEmail: (state) => state.bid.person_email,
      stateOgrn: (state) => state.bid.ogrn,
      stateFirstname: (state) => state.bid.person_firstname,
      stateSurname: (state) => state.bid.person_surname,
      stateMiddlename: (state) => state.bid.person_middlename,
      stateComment: (state) => state.bid.comment,
      stateInnPhysical: (state) => state.bid.inn_physical,
      stateCompanyName: (state) => state.bid.company_name,
      showNewBid: (state) => state.common.showNewBid,
      clientType: (state) => state.bid.client_type,
      passportFiles: (state) => state.bid.passportFiles,
      formFiles: (state) => state.bid.formFiles,
    }),
    products: {
      get() {
        return this.stg;
      },
      set(value) {
        this.set({ type: "stg", value });
      },
    },
    company: {
      get() {
        return this.$store.state.bid.company;
      },
      set(value) {
        this.$store.commit("bid/set", { type: "company", value });
      },
    },
    company_name: {
      get() {
        return this.stateCompanyName;
      },
      set(value) {
        this.set({ type: "company_name", value });
      },
    },

    inn: {
      get() {
        return this.stateInn;
      },
      set(value) {
        this.set({ type: "inn", value });
      },
    },
    phone: {
      get() {
        return this.statePhone || "";
      },
      set(newVal) {
        const _value = formatPhone(newVal);
        this.set({ type: "person_phone", value: _value });
      },
    },
    email: {
      get() {
        return this.stateEmail;
      },
      set(value) {
        this.set({ type: "person_email", value });
      },
    },
    ogrn: {
      get() {
        return this.stateOgrn;
      },
      set(value) {
        this.set({ type: "ogrn", value });
      },
    },
    person_firstname: {
      get() {
        return this.stateFirstname;
      },
      set(value) {
        this.set({ type: "person_firstname", value });
      },
    },
    person_surname: {
      get() {
        return this.stateSurname;
      },
      set(value) {
        this.set({ type: "person_surname", value });
      },
    },
    person_middlename: {
      get() {
        return this.stateMiddlename;
      },
      set(value) {
        this.set({ type: "person_middlename", value });
      },
    },
    inn_physical: {
      get() {
        return this.stateInnPhysical;
      },
      set(value) {
        this.set({ type: "inn_physical", value });
      },
    },
    comment: {
      get() {
        return this.stateComment;
      },
      set(value) {
        this.set({ type: "comment", value });
      },
    },

    client_type: {
      get() {
        return this.clientType;
      },
      set(value) {
        this.set({ type: "client_type", value });
      },
    },
    // Для валидации соответствия ИНН - ОГРН
    isInnIp() {
      return !!this.inn && this.inn.length === 12;
    },
    isInnUl() {
      return !!this.inn && this.inn.length === 10;
    },
    isOgrn() {
      return !!this.ogrn && this.ogrn.length === 13;
    },
    isOgrnip() {
      return !!this.ogrn && this.ogrn.length === 15;
    },
    isInnMatchOgrn() {
      return this.isOgrn ? this.isInnUl : this.isOgrnip ? this.isInnIp : true;
    },
    isOgrnMatchInn() {
      return this.isInnUl ? this.isOgrn : this.isInnIp ? this.isOgrnip : true;
    },
    ogrnLabel() {
      return this.isInnIp ? "ОГРНИП" : this.isInnUl ? "ОГРН" : "ОГРН/ОГРНИП";
    },
  },
  watch: {
    company(company) {
      if (company) {
        this.inn = company.inn;
        this.ogrn = company.ogrn;
      } else {
        this.inn = "";
        this.ogrn = "";
      }
    },
    showNewBid(show) {
      if (!show) {
        this.resetValidation();
      }
    },
    // для повторной валидации в случае изменения типа инн / огрн
    isInnUl() {
      if (this.ogrn) {
        this.validateInnAndOgrn();
      }
    },
    isInnIp() {
      if (this.ogrn) {
        this.validateInnAndOgrn();
      }
    },
    isOgrn() {
      if (this.inn) {
        this.validateInnAndOgrn();
      }
    },
    isOgrnip() {
      if (this.inn) {
        this.validateInnAndOgrn();
      }
    },
    stg(newValue, oldValue) {
      const cloudPayIndex = this.productList.findIndex((element) => element.value === "CLOUDPAY");
      if (cloudPayIndex !== -1) {
        this.$set(this.productList, cloudPayIndex, {
          ...this.productList[cloudPayIndex],
          disabledState: newValue.includes("ACCOPEN") === false,
        });
      }
    },
  },
  mounted() {
    this.client_type = 'FL';
  },

  methods: {
    ...mapMutations("bid", ["set"]),
    ...mapActions("bid", ["createAutoCredit"]),
    handleCreateCompany() {
      this.isNewCompany = true;
      this.company = null;
    },
    resetValidation() {
      this.isNewCompany = false;
      this.$refs.form.resetValidation();
    },
    sendBid() {
      this.createAutoCredit();
      this.resetValidation();
    },
    validateInnAndOgrn() {
      this.$refs.form.inputs.forEach((i) => {
        if (i.$attrs.name === "ogrn" || i.$attrs.name === "inn") {
          i.validate();
        }
      });
    },
  },
  components: {
    MaskedTextField,
    CompanySearch,
    AutocreditUploadSection,
  },
};
</script>

<style scoped>
.link-contract {
  background: #f5f5f6;
  border-radius: 3px;
  padding: 14px 14px;
}

.v-input--selection-controls {
  margin-top: 0px;
  padding-top: 0px;
}
</style>
